import './freeCaseStyles.scss';
//import Button from '../ui/button';
import {
  FunctionComponent,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Case as CaseType } from '~types';
import { Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import { useConfig } from '~frontend/components/hooks';
import Currency from '~frontend/components/Currency';
import Free1 from '../../../scss/images/free-1.png';
import Free2 from '../../../scss/images/free-2.png';
import { Price } from '~shared/frontend/ui';
import { GetName } from '~frontend/components/item';

interface FreeCaseProps {
  getCase: CaseType;
}

const FreeCaseNew: FunctionComponent<FreeCaseProps> = ({ getCase }) => {
  const getActiveGame = getCase?.getActiveGame;
  const { t } = useTranslation();
  const getConfig = useConfig();

  // Объект с сопоставлением цветов и названий классов
  const rarityColors = {
    b0c3d9: 'item_card_consumer',
    '4b69ff': 'item_card_military',
    '5e98d9': 'item_card_industrial',
    '8847ff': 'item_card_restricted',
    d32ce6: 'item_card_classified',
    eb4b4b: 'item_card_covert',
    ffc600: 'item_card_legendary',
  };

  // Функция для получения названия класса по цвету
  const getRarityClassName = useCallback((color) => {
    return rarityColors[color] || '';
  }, []);

  const rarityClassName = useMemo(
    () => getRarityClassName(getActiveGame?.getItem.color),
    [getActiveGame?.getItem.color, getRarityClassName],
  );

  return (
    <div className="case_opened">
      <div className="case_opened_container_free">
        <div className="case_opened_free_item">
          <img
            src={Free1}
            alt="free-1"
            width={264}
            height={264}
            className="item_image_free"
          />
          <div className="item_free_descr">
            <span>
              {' '}
              {getCase?.seo?.inputMoney} <Currency />
            </span>
            <span>{t('to the account')}</span>
          </div>
        </div>
        <div
          //key={item.id}
          className={`item_card 
            ${rarityClassName} item_card_full_width`}
        >
          <div className="item_price">
            {' '}
            {getConfig.isEU ? (
              <>
                <Currency />
                <Price sum={getActiveGame?.price} />
              </>
            ) : (
              <>
                <Price sum={getActiveGame?.price} />
                <Currency />
              </>
            )}
          </div>
          {/* <div className="item_chance">{getActiveGame?.chance}%</div> */}
          <div className="item_image_container1">
            <img
              src={getActiveGame?.getItem?.getImage}
              alt={`item`}
              width={180}
              height={120}
              className="item_image"
            />
          </div>
          <div className="item_info">
            <div className="item_name">
              <GetName getItem={getActiveGame?.getItem} type={0} />
            </div>
            <div className="item_skin">
              <span>{getActiveGame?.getItem?.quality || 'FN'}</span> |{' '}
              {<GetName getItem={getActiveGame?.getItem} type={1} />}
            </div>
          </div>
        </div>
        <div className="case_opened_free_item">
          <img
            src={Free2}
            alt="free-2"
            width={264}
            height={264}
            className="item_image_free"
          />
          <div className="item_free_descr">
            <span>30</span>
            <span>{t('free_case_opening_on_case')}</span>
          </div>
        </div>
      </div>

      {/* <div className={styles.case_opened_actions}>
        <div className={styles.case_opened_left_group}>
          <Button
            type="button"
            text="Играть ещё"
            className="btn_blue_bordered"
          />
        </div>

        <div className={styles.case_opened_center_group}>
          <Button
            type="button"
            text="Продать выбранное за $ 12"
            className="btn_green"
          />
        </div>

        <div className={styles.case_opened_right_group}>
          <Button
            type="button"
            text="В апгрейды"
            className="btn_tab_bordered"
          />
          <Button
            type="button"
            text="В контракты"
            className="btn_tab_bordered"
          />
        </div>
      </div> */}
    </div>
  );
};

export default memo(FreeCaseNew);
